module.exports = __webpack_public_path__ + "assets/img/9fc1fb06b5a49fddb9e39c45e511bdab.png";